import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 1C6.5 0.723858 6.27614 0.5 6 0.5C5.72386 0.5 5.5 0.723858 5.5 1V2C5.5 2.27614 5.72386 2.5 6 2.5C6.27614 2.5 6.5 2.27614 6.5 2V1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 10C6.5 9.72386 6.27614 9.5 6 9.5C5.72386 9.5 5.5 9.72386 5.5 10V11C5.5 11.2761 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.2761 6.5 11V10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 6C0.5 5.72386 0.723858 5.5 1 5.5H2C2.27614 5.5 2.5 5.72386 2.5 6C2.5 6.27614 2.27614 6.5 2 6.5H1C0.723858 6.5 0.5 6.27614 0.5 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.8035 2.0964C2.60824 1.90114 2.29166 1.90114 2.0964 2.0964C1.90114 2.29166 1.90114 2.60824 2.0964 2.8035L2.8035 3.51061C2.99877 3.70587 3.31535 3.70587 3.51061 3.51061C3.70587 3.31535 3.70587 2.99877 3.51061 2.8035L2.8035 2.0964Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.90362 2.0964C10.0989 2.29166 10.0989 2.60824 9.90362 2.8035L9.19651 3.51061C9.00125 3.70587 8.68467 3.70587 8.4894 3.51061C8.29414 3.31535 8.29414 2.99877 8.4894 2.8035L9.19651 2.0964C9.39177 1.90114 9.70835 1.90114 9.90362 2.0964Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.51061 9.19852C3.70587 9.00326 3.70587 8.68668 3.51061 8.49142C3.31535 8.29615 2.99877 8.29615 2.8035 8.49142L2.0964 9.19852C1.90114 9.39379 1.90114 9.71037 2.0964 9.90563C2.29166 10.1009 2.60824 10.1009 2.8035 9.90563L3.51061 9.19852Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4894 8.49142C8.68467 8.29615 9.00125 8.29615 9.19651 8.49142L9.90362 9.19852C10.0989 9.39379 10.0989 9.71037 9.90362 9.90563C9.70835 10.1009 9.39177 10.1009 9.19651 9.90563L8.4894 9.19852C8.29414 9.00326 8.29414 8.68668 8.4894 8.49142Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 5.5C9.72386 5.5 9.5 5.72386 9.5 6C9.5 6.27614 9.72386 6.5 10 6.5H11C11.2761 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.2761 5.5 11 5.5H10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3Z",
			fill: "currentColor"
		})
	]
});
export default SvgSun;
